<div class="box">
    <span class="box-header"></span>
    <div class="box-content"></div>
</div>